import {useIssueCreateMetadata} from '@github-ui/issue-create/IssueCreateDataContext'
import {useMemo} from 'react'

import type {DraftIssue} from '../content-preview-types'
import {useDraftIssueFormSync} from './use-draft-issue-form-sync'
import {useMilestoneQuery} from './use-milestone-query'
import {useOnChangeCallback} from './use-on-change-callback'

function isEqual(left: string | undefined, right: string | undefined) {
  return left?.toLowerCase() === right?.toLowerCase()
}

export function useDraftIssueMilestone(draftIssue: DraftIssue) {
  const {
    repository: formRepository,
    milestone: formMilestone,
    setMilestone: setFormMilestone,
  } = useIssueCreateMetadata()
  const onChange = useOnChangeCallback(draftIssue)

  const resolverQuery = useMilestoneQuery({
    owner: formRepository?.owner.login,
    repo: formRepository?.name,
    milestone: draftIssue.milestone,
  })
  const resolvedMilestone = useMemo(() => resolverQuery.data?.[0] ?? null, [resolverQuery.data])

  return useDraftIssueFormSync(draftIssue, {
    draftValue: draftIssue.milestone,
    formValue: formMilestone,
    setFormValue: setFormMilestone,
    onChange: (newValue, skipVersionBump) => onChange({milestone: newValue?.title}, skipVersionBump),
    resolverResult: {
      isLoading: resolverQuery.isLoading,
      data: resolvedMilestone,
    },
    hasPermission: repo => repo?.viewerIssueCreationPermissions?.milestoneable,
    isEqual: (a, b) => isEqual(a?.title, b?.title),
    defaultValue: null,
  })
}
